import type { AnalyticsSearchStatsParams } from '~/services/AnalyticsService';

export const analyticsQueryKeys = {
  all: ['analytics'] as const,
  stats: (params: AnalyticsSearchStatsParams) => [...analyticsQueryKeys.all, 'stats', params] as const,
  statsIdle: () => [...analyticsQueryKeys.all, 'stats', 'idle'] as const,
};
